import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import {
  ErrorDetails,
  TotalDriversResponseDTO
} from '../../interfaces/apiInterfaces';

export class GetDriversListCommand extends IRequestCommand<
  IGetDriversListResponse,
  ErrorDetails,
  IGetDriversListCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierUserId}/drivers/driver?name={driverName}';
  public override setParameters(parameters: IGetDriversListCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      parameters.carrierUserId
    );
    this._commandUrl = this._commandUrl.replace(
      '{driverName}',
      parameters.driverName ? parameters.driverName.toString() : ''
    );
  }
}

export interface IGetDriversListCommandParameters extends ICommandParameters {
  carrierUserId: string,
  driverName: string
}

export interface IGetDriversListResponse
  extends ICommandResponse { }
